import component from './index';
import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper footer4',
    },
    left: {
      className: 'left',
      children: 'https://imm.86links.com/assets/landing/footer/template/footer4-left.png',
    },
    right: {
      className: 'right-wrap',
    },
    rightTop: {
      className: 'right-top',
      children: [
        {
          name: 'image',
          children: 'https://imm.86links.com/assets/landing/footer/template/address-icon.png',
          className: 'icon',
        },
        {
          name: 'address',
          children: '成都市龙泉驿区龙泉街道星光中路18号',
          className: 'address',
        },
      ],
    },
    rightBottom: {
      className: 'right-bottom',
      children: [
        {
          name: 'image',
          children: 'https://imm.86links.com/assets/landing/footer/template/address-icon.png',
          className: 'icon',
        },
        {
          name: 'mobile',
          children: '028-84853326',
          className: 'mobile',
        },
      ],
    },
  },
};
